import {
  SearchContent,
  SEARCH_CONTENT,
  ResetSearchContent,
  RESET_SEARCH_CONTENT,
} from '../types/search/search';
import { SearchOutDto } from '../../types/search.dto';

export const searchContent = (payload: SearchOutDto): SearchContent => ({
  type: SEARCH_CONTENT,
  payload,
});

export const resetSearchContent = (): ResetSearchContent => ({
  type: RESET_SEARCH_CONTENT,
  payload: null,
});
